module.exports = __webpack_public_path__ + "media/images/boxes/cms-box143-e2b855c6bce124e007cf3272cc105717.png";